import { MalaysianCitizenStatus } from "core/const/MalaysianCitizenStatus";

export const IsMalaysianCitizenOptions = [
  { checkValue: MalaysianCitizenStatus.Yes, label: 'Yes, I am a Malaysian citizen' },
  { checkValue: MalaysianCitizenStatus.No, label: 'No, I am not a Malaysian citizen' },
];